import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.getNetworth || initialState;

export const selectGetNetworth = createSelector([selectSlice], state => state);
